module.exports = __webpack_public_path__ + "img/slider-bg.b1e99f9e.png";